
import App from './App.vue'
import { createApp } from 'vue'
import './style.css'
import 'preline'
import 'altcha'
import $ from "jquery";
import _ from "lodash";
import noUiSlider from "nouislider";
import "datatables.net";
import "dropzone/dist/dropzone-min.js";
import * as VanillaCalendarPro from "vanilla-calendar-pro";

window._ = _;
window.$ = $;
window.jQuery = $;
window.DataTable = $.fn.dataTable;
window.noUiSlider = noUiSlider;
window.VanillaCalendarPro = VanillaCalendarPro;
// Plugins
import { registerPlugins } from '@/plugins/index'
import { useTheme } from '@/modules/Core/composables/useTheme';
import { getItemConExpiracion } from './modules/Core/usings/generales';
import { setAppContext } from './modules/Core/composables/useAppContext';
import { initErrorReporter } from '@/modules/Core/errores';

const app = createApp(App)

registerPlugins(app)

initErrorReporter(app) // Captura centralizada de errores (Vue + window + promesas)

useTheme().init()
setAppContext(app._context) // Establecer el contexto de la aplicación
app.mount('#app')

window['getItemConExpiracion'] = getItemConExpiracion 
